import { render, staticRenderFns } from "./Search.vue?vue&type=template&id=244c8a90&scoped=true&"
import script from "./Search.vue?vue&type=script&lang=js&"
export * from "./Search.vue?vue&type=script&lang=js&"
import style0 from "./Search.sass?vue&type=style&index=0&id=244c8a90&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244c8a90",
  null
  
)

export default component.exports